import React, { FC, useContext, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Avatar from "./Avatar";
import { GlobalDataContext } from "contexts/GlobalData";

export interface PageLoginProps {
  className?: string;
}

//const SITE_HOME = ;

const MeHead: FC<PageLoginProps> = ({ className = "" }) => {

	const { 
		initData,
	} = useContext (GlobalDataContext);
	
	const handleClickAdmin = async (e: any) => {
		
		
		window.location.href = `${process.env.REACT_APP_SERVER_ADMIN}`;
	};

	console.log(initData.token_info.permission_group)

	return (
		<>
			<div
				className={`nc-Section-Heading relative flex items-center justify-between ${className}`}
			>
				<div
					className={`max-w-2xl`}
				>
					<h2 className={`text-xl md:text-2xl font-semibold`}>
						프로필
					</h2>
					
				</div>
				<div>
					{(initData.token_info.permission_group === "agency" || initData.token_info.permission_group === "super") && (
						<>
							<button 
								type="button"
								onClick={handleClickAdmin}
								style={{color: "blue"}}
							>
								관리 페이지 이동
							</button>
						</>
					)}
				</div>
			</div>
		</>
  	);
};

export default MeHead;
